import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { InstantWin } from 'models/instantWin';
import { InstantWinEvent } from 'models/instantWinEvent';

import styles from './Prize.module.css';

interface Props {
  onClose: () => void;
  instantWin: InstantWin;
  instantWinEvent: InstantWinEvent;
  tierKey: string;
}

export const PromoCode = ({ onClose, instantWin, instantWinEvent, tierKey }: Props): any => {
  const { t } = useTranslation();

  const promoCode = instantWinEvent?.promo_code ?? '';
  const tier = instantWin?.tiers?.find((tier) => tier?.key === tierKey);
  const keyVisual = tier?.thumbnail_url;
  const title = tier?.title;
  const description = tier?.description;
  const promo_book_date_local_from = instantWinEvent?.promo_book_date_local_from;
  const promo_book_date_local_to = instantWinEvent?.promo_book_date_local_to;

  return (
    <>
      <div className={styles.ticketContainer}>
        <div className={styles.congratsSection}>
          <div className={`${styles.divider} ${''}`} />
          <div className={styles.congratsText}>Congratulations!</div>
          <div className={`${styles.divider} ${''}`} />
        </div>
        <div className={styles.ticketPreview}>
          <img src={keyVisual} alt="e-ticket" className={styles.ticketImage} />
          <h2 className={styles.ticketName}>{title}</h2>
        </div>
      </div>

      <div className={styles.ticketContainer}>
        <div className={styles.ticketTitle}>{description}</div>
        <div className={styles.promotionContainer}>
          <div className={styles.promotionWrapper}>
            <div className={styles.promotionTitle}>{title}</div>
            <div className={styles.dateRange}>
              {promo_book_date_local_from && (
                <>
                  {t('Booked Date')}：{promo_book_date_local_from} ~ {promo_book_date_local_to}
                  <br />
                </>
              )}
              {instantWinEvent?.promo_participation_dates?.map((d) => {
                return (
                  <>
                    {t('Participation Date')}：{d ? d.start_date_local : '-'} ~{' '}
                    {d ? d.end_date_local : '-'}
                    <br />
                  </>
                );
              })}
            </div>
            <div className={styles.promoCode}>{promoCode}</div>
          </div>
        </div>
        <div className={styles.buttonGroup}>
          <button
            className={styles.primaryButton}
            onClick={() => {
              navigator.clipboard.writeText(promoCode);
            }}
          >
            {t('Copy Promo Code')}
          </button>
          <button className={styles.secondaryButton} onClick={onClose}>
            {t('Close')}
          </button>
        </div>
      </div>
    </>
  );
};
